<template>
  <div>
    <a-modal v-model="visible" width="960px" title="视图配置" :footer="false" @cancel="cancel">
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="6">
          <a-card size="small" title="视图列表">
            <a slot="extra" @click="onAdd"> <a-icon type="plus" /> 添加视图 </a>
            <a-empty v-if="views.length === 0" />
            <div v-for="(view, index) in views" :key="index">
              <div :class="`${view.id === currentView ? 'view-item view-item_active' : 'view-item'}`" @click="onView(view)">
                <span class="view-item_name">
                  <a-checkbox :checked="view.is_default === 1" @change="onSetDefault($event, view)"> <span style="color: #1890fc">默认</span></a-checkbox>
                  <span>{{ view.name }}</span>
                </span>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col class="gutter-row" :span="18">
          <a-form-model ref="form" :form="form" :rules="rules" :model="form">
            <a-form-model-item label="视图名称" prop="name">
              <a-input v-model="form.name" placeholder="视图名称" class="form-model-item" />
            </a-form-model-item>
          </a-form-model>
          <a-form-model :form="paramForm" :model="paramForm">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="标题">
                  <a-input v-model="paramForm.title" placeholder="缺陷标题" class="form-model-item" allow-clear />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="状态">
                  <a-select v-model="paramForm.status" mode="multiple" :max-tag-count="2" allow-clear placeholder="状态">
                    <a-select-option v-for="(item, index) in ticketStatus" :key="index" :value="item.value">
                      <a-tag :color="item.color">{{ item.label }}</a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="优先级">
                  <a-select v-model="paramForm.level" mode="multiple" :max-tag-count="2" allow-clear placeholder="等级">
                    <a-select-option v-for="(item, index) in ticketLevel" :key="index" :value="item.value">
                      <a-tag :color="item.color"> {{ item.label }} </a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="业务域">
                  <a-select v-model="paramForm.domain" mode="multiple" allow-clear placeholder="业务域">
                    <a-select-option v-for="(item, index) in ticketDomain" :key="index" :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="ai准确性">
                  <a-select v-model="paramForm.aiResult" mode="multiple" allow-clear placeholder="ai准确性">
                    <a-select-option v-for="(item, index) in ticketAiResult" :key="index" :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="处理时长">
                  <a-input-number v-model.number="paramForm.overTime" :min="0" :max="24" :step="1" :precision="0" :parser="val => (val === '' ? null : parseInt(val, 10))" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="问题类型">
                  <a-tree-select v-model="paramForm.tags" show-search multiple :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 100%" :tree-data="showTagList" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="工单排查人">
                  <a-select v-model="paramForm.handler" mode="multiple" allow-clear placeholder="工单排查人" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="工单对接人">
                  <a-select v-model="paramForm.maintainer" mode="multiple" allow-clear placeholder="工单对接人" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="工单类型">
                  <a-select v-model="paramForm.type" mode="multiple" allow-clear placeholder="工单类型">
                    <a-select-option v-for="(item, index) in ticektType" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="时间类型">
                  <a-radio-group v-model="paramForm.time_field">
                    <a-radio value="created_time"> 创建时间 </a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="时间范围">
                  <a-date-picker v-model="paramForm.begin_time" class="customer-date-picker" placeholder="开始时间" value-format="YYYY-MM-DD" />
                  <a-date-picker v-model="paramForm.end_time" class="customer-date-picker" placeholder="结束时间" value-format="YYYY-MM-DD" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="与我相关">
                  <a-radio-group v-model="paramForm.about" button-style="solid">
                    <a-radio-button value="all"> 全部 </a-radio-button>
                    <a-radio-button value="about"> 与我相关 </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-model-item label="展示字段">
                  <a-select v-model="paramForm.fields" placeholder="选择展示字段" allow-clear mode="multiple" style="width: 100%; margin-right: 8px">
                    <a-select-option v-for="(item, index) in ticketFields" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-model-item style="text-align: center; margin-top: 12px">
                  <a-button type="primary" @click="onSave"> 保存 </a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import { userList } from '@/api/system/auth';
import { viewList, viewAdd, viewModify, setDefaultView } from '@/api/project/view';
import { ticketStatus, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus, ticketFields, ticketAiResult, ticektType } from '@/utils/dictionary';
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    },
    showTagList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      ticketDomain,
      ticketStatus,
      ticketAiResult,
      ticketLevel,
      ticektType,
      ticketFields,
      ticektTag,
      qiyuTicketStatus,
      form: {},
      paramForm: {
        about: 'all',
        time_field: 'created_time',
        fields: []
      },
      views: [],
      userData: [],
      versionData: [],
      visible: false,
      isEdit: false,
      currentView: null,
      projectId: parseInt(this.$route.params.project_id) || 0,
      rules: {
        name: [{ required: true, message: '视图不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getViewList();
        this.getUserList();
      }
    }
  },
  methods: {
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    onSetDefault(e, view) {
      setDefaultView({ project_id: this.projectId, category: 'ticket', id: view.id, is_default: e.target.checked ? 1 : 0 }).then(() => {
        this.$message.success('设置默认视图成功');
        this.getViewList();
      });
    },
    cancel() {
      this.$emit('close');
    },
    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users.filter(user => user.isDeleted !== 1 && user.fs_user_id !== '' && user.fs_user_id !== null);
      });
    },
    getViewList() {
      viewList({ project_id: this.projectId, category: 'ticket' }).then(res => {
        this.views = res.data.private;
        if (this.views.length > 0 && this.currentView === null) {
          const view = this.views[0];
          this.form = { name: view.name };
          this.currentView = view.id;
          this.paramForm = view.params;
          if (!this.paramForm.time_field) {
            this.paramForm.time_field = 'created_time';
          }
        }
      });
    },
    onView(record) {
      this.currentView = record.id;
      this.form = { name: record.name };
      this.paramForm = record.params;
      if (!this.paramForm.time_field) {
        this.paramForm.time_field = 'created_time';
      }
    },
    onAdd() {
      this.form = { name: null };
      this.paramForm = { about: 'all', time_field: 'created_time' };
      this.currentView = null;
      this.isEdit = true;
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.currentView === null) {
            // 添加视图
            viewAdd({ ...this.form, project_id: this.projectId, category: 'ticket', view_type: 1, params: this.paramForm }).then(() => {
              this.$message.success('添加成功');
              this.getViewList();
            });
          } else {
            // 修改视图
            viewModify({ ...this.form, id: this.currentView, project_id: this.projectId, view_type: 1, params: this.paramForm }).then(() => {
              this.$message.success('修改成功');
              this.getViewList();
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 4px;
  }
  .ant-form-item-label {
    line-height: 28px;
  }
}
/deep/.ant-card-body {
  padding: 8px 0;
  height: 400px;
  overflow: auto;
}

.view-item {
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 12px;
  width: 100%;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) 需与 overflow:hidden;一起使用。*/
}

.view-item:hover,
.view-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.view-item_more {
  float: right;
  font-weight: bold;
}
.customer-date-picker {
  width: calc(50% - 3px);
}
</style>
